/* eslint-disabled */

export default class TenantExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
